import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { bindAll } from '@bibliocommons/utils-react';

import FullScreenOverlay from 'app/components/deprecated/shared/FullScreenOverlay';
import { TableStencil } from 'app/components/shared/Table';
import { isConjunctiveField } from 'app/helpers/facets/filterUtils';
import { filterShape } from 'app/shapes/search';
import CheckboxFilter from '../CheckboxFilter';
import LinkFilter from '../LinkFilter';
import './ExpandedFiltersOverlay.scss';

class ExpandedFiltersOverlay extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
  }

  renderFilter(filter) {
    const { fieldId } = this.props;

    let classString = 'filter';
    if (filter.get('applied')) {
      classString += ' applied';
    }

    const FilterTag = isConjunctiveField(fieldId) ? LinkFilter : CheckboxFilter;
    const value = filter.get('value');

    return (
      <li key={filter.get('value')} className={`${classString} col-sm-6 col-md-6`}>
        <div className="expanded-filter-label-wrap">
          <FilterTag
            fieldId={fieldId}
            filter={filter}
            handleToggleFilter={this.props.handleToggleExpandedField}
            id={`FiltersOverlay_${fieldId}_${value}`}
          />
        </div>
      </li>
    );
  }

  render() {
    const { isFetching } = this.props;

    return (
      // The `disablePushState` prevents the overlay from using history.back()
      // to close. Othwerwise it'll revert any newly added facets in the url.
      <FullScreenOverlay {...this.props} disablePushState data-test-id={`${this.props.fieldId}-more-filters-overlay`}>
        <h1>
          <FormattedMessage
            id="expanded_filter_header"
            values={{
              field: this.props.intl.formatMessage({
                id: this.props.label || `${this.props.fieldId}.field`
              })
            }}
          />
        </h1>
        {isFetching ? (
          <TableStencil />
        ) : (
          <ul className="expanded-filter-list">{this.props.filters.valueSeq().map(this.renderFilter)}</ul>
        )}
      </FullScreenOverlay>
    );
  }
}

ExpandedFiltersOverlay.propTypes = {
  fieldId: PropTypes.string.isRequired,
  handleToggleExpandedField: PropTypes.func.isRequired,
  filters: ImmutablePropTypes.listOf(filterShape).isRequired,
  isFetching: PropTypes.bool.isRequired,
  open: PropTypes.bool,
  label: PropTypes.string,
  handleClose: PropTypes.func.isRequired
};

export default injectIntl(ExpandedFiltersOverlay);
